"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { workspaceAppsApi } from "../api";
import { invalidateWorkspaceApps } from "./invalidateWorkspaceApps";

type PresetApplyPayload = Parameters<typeof workspaceAppsApi.applyPreset>[2];
type PresetPreviewPayload = Parameters<typeof workspaceAppsApi.getPresetApplyPreview>[2];

export function useWorkspacePresetApplyPreviewMutation(
  workspaceUuid: string,
  presetCode: string,
) {
  return useMutation({
    mutationFn: (data: PresetPreviewPayload) => (
      workspaceAppsApi.getPresetApplyPreview(workspaceUuid, presetCode, data)
    ),
  });
}

export function useApplyWorkspacePresetMutation(workspaceUuid: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ presetCode, data }: { presetCode: string; data: PresetApplyPayload }) => (
      workspaceAppsApi.applyPreset(workspaceUuid, presetCode, data)
    ),
    onSuccess: async () => {
      await invalidateWorkspaceApps(queryClient, workspaceUuid);
    },
  });
}
